import { useHasFlag } from "../../auth";
import { SuperEmitterProgramDashboard } from "../../components/dashboards/SuperEmitterProgramDashboard";
import { PermissionGate } from "../PermissionGate";

export const SuperEmitterProgramDashboardPage = () => {
    const epaSepEnabled = useHasFlag("enable_epa_sep");

    if (!epaSepEnabled) {
        return null;
    }

    return (
        <PermissionGate permission="emissionView" requiredFlag="enable_epa_sep">
            <SuperEmitterProgramDashboard />
        </PermissionGate>
    );
};
